import styled from "styled-components";
import theme from "../../../styles/theme";

export const ButtonSys = styled.button<{
  color: string;
  bgColor: string;
  hoverBgcolor: string;
  disabledBgColor: string;
  borderColor: string;
}>`
  width: 100%;
  padding: 9.45px;
  background-color: ${(props) => props.bgColor};
  border: none;
  border-radius: 4px;
  font-size: ${theme.fontSize.mm};
  cursor: pointer;
  display: flex;
  column-gap: 5px;
  align-items: center;
  height: fit-content;
  justify-content: center;
  border-style: ${(props) => (props.borderColor ? "solid" : "none")};
  border-color: ${(props) => props.borderColor ?? "transparent"};
  border-width: 1px;
  color: ${(props) => props.color ?? "white"};
  &:hover {
    background-color: ${(props) => props.hoverBgcolor};
    border-color: ${(props) => props.borderColor ?? "transparent"};
  }
  &:disabled {
    background-color: ${(props) => props.disabledBgColor};
    cursor: not-allowed;
  }
`;
